module.exports = __webpack_public_path__ + "static/media/calefont10.5491b5d7.png";